module.exports = __webpack_public_path__ + "media/images/work_tibor-95242f5b47b489f89730ad23932648dd.png";